angular.module('dpw.components').component('dpwDevPackagePromotion', {
    templateUrl: 'dpw-dev-package-promotion.component.html',
    controllerAs: 'ctrl',
    bindings: {},
    controller: ['$scope', '$q', 'dpwStorage', 'organizationService', 'user', 'helpers', 'api',
        function ($scope, $q, dpwStorage, organizationService, user, helpers, api) {
            var self = this;
            var notShowIn24HoursKey = '';

            self.visible = false;
            self.doNotShow = false;

            $scope.$on('$routeChangeSuccess', function () {
                if (helpers.isAppListPage()) {
                    $q.all([
                        user.fetch(),
                        organizationService.getOrganization(),
                        isDevAccountSignUpEnabled()
                    ]).then(function (results) {
                        var userObj = user.getUser();
                        notShowIn24HoursKey = 'NotShowDevPackagePromotionIn24Hours' + userObj.extensionId;

                        var org = results[1];
                        var isCustomer = organizationService.isCustomer(org);
                        var isSignUpEnabled = results[2];
                        self.visible = isCustomer && isSignUpEnabled && !isLessThan24Hours();
                    });
                } else {
                    self.visible = false;
                }
            });

            self.dismiss = function () {
                self.visible = false;
                dpwStorage.setItem(notShowIn24HoursKey, new Date().getTime());
            };

            function isLessThan24Hours() {
                var preTime = parseInt(dpwStorage.getItem(notShowIn24HoursKey), 10);
                return helpers.isLessThan24Hours(preTime);
            }

            function isDevAccountSignUpEnabled() {
                return $q(function (resolve) {
                    api.call(api.devTrialUser.isSignUpEnabled(), function (res) {
                        resolve(res.result);
                    });
                });
            }
        }]
});
